import { PersonalInformationDetails } from "./personal-information-details";
import { MembershipDetails } from "./membership-details";
import { EducationDetails } from "./education-details";
import { ChapterDetails } from "./chapter-details";
import { Addresses, Phones } from "./my-account-data.models";
import { MembershipProfile } from "./profile";
import { OrderGenProduct } from "./common.data.models";
import { SectionDetails } from "./section-details";
import { NotifyInfo } from "./notify";
import { OrderDetails } from "@acepteam/payment";


export class GroupPortalData {
    //UI TABS
    personalInfo: PersonalInformationDetails;
    membershipDetails: MembershipDetails;
    educationDetails: EducationDetails;
    chapterDetails: ChapterDetails;
    sectionDetails: SectionDetails;
    orderDetails: OrderDetails;
    notifyInfo: NotifyInfo;

    //GENERAL
    profile: MembershipProfile;
    addresses: Addresses;
    phones: Phones;
    orderGenProducts: OrderGenProduct[] = [];

    //UI Purposes
    AccountProducts: any = [];
    ContentSnippets: any = [];
}

export class GroupInfo {
    accountContacts: Group[] = [];
    selectedGroup: Group;
    groupNumber: String = '';
    GroupInfo: any;
    FormGroupInfo: any;
    RegisterData: any;
    Director: Contact;
    Coordinator: Contact;
    Administrator: Contact;
    groupInvoices: Invoice[] = [];
    paymentTypes: any = [];
    allMembers: any = [];
    selectedMembers: any = [];
    ResidentInvoiceData: any = [];
    selectedAmount: number;
    searchContactList: SearchContact[] = [];
    slideOutType: String;
    //pga: Feature-2920 new properties for Recall and Apply Payment
    hasSubmittedStatus: boolean; 
    outstandingTotal: number; 
    submittedGBN: string;
    submittedMemberCount: number;
}

export class AcepContact {
    //Input only
    prefix = '';
    FirstName = '';
    MiddleName = '';
    LastName = '';
    jobTitle = '';
    NPINumber = '';
    AddressType: any = 1;
    Country = '';
    AddressAttention = '';
    Street = '';
    City = '';
    Apt = '';
    State = '';
    Zip = '';
    EmailAddress = '';
    Phone = '';
    startDate = '';
    endDate = '';
    Chapter = '';
    MedicalLicense: any = null;
    Membership: any = null;
    groupBilling: boolean = true;
    ContactID = '';
    ACEPID = '';
    showSuccessMsg: boolean;
    residency ={
        id : '' ,
        specialityId:'',
        gradYear : ''
    };
}

export class Invoice {
    date = '';
    groupBillNumber = '';
    status = '';
    amount = '';
}
export class HeaderInfo {
    groupName = '';
    groupId = '';
    members = 0;
    dueDate: any = null;
    amountDue = 0;
}

export class MemberCounts {
    ready = 0;
    pending = 0;
    paid = 0;
    totalMembers = 0;
    percentofPieSliceReadyForPayment = 0;
    percentofPieSlicePending = 0;
    percentofPieSlicePaid = 0;
    percentofPieSliceNotInGB = 0;
    strokeoffsetReadyForPayment = 0;
    strokeoffsetPending = 0;
    strokeoffsetPaid = 0;
    strokeoffsetNotInGB = 0;
    notInGB = 0;
    showChart = false;
    //pga: Feature-2920 new property for submitted
    submitted = 0;
}

export class Contact {
    beginDate: Date;
    contactNo: String;
    endDate: Date;
    formalName: String;
    position: String;
}

export class SearchContact {
    formalName: String;
    acepId: String;
    npiNumber: String;
    city: String;
    state: String;

}

export class Group {
    acepId: any = '';
    accountName: any = '';
    accountCategory: any = '';
    role: any = '';
}

export class paymentMethod {
    nameOnCard: String;
    creditCardNumber: String;
    ccExpirationDate: Date;
    ccShortDate: any;
    cardExpired: boolean;
    cardType: any;
}

export enum statusCodesEnum {
    AllMembers = -1,
    NotInGroupBill = 0,
    ReadyForPayment = 1,
    Pending = 2,
    Paid = 3,
    Processing = 4,
    Submitted = 5
  }
